import { create } from 'zustand';

interface UiState {
  isSidebarCollapsed: boolean;
  isUserMenuOpen: boolean;
  isNotificationMenuOpen: boolean;
  toggleSidebar: () => void;
  setUserMenuOpen: (open: boolean) => void;
  setNotificationMenuOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  isSidebarCollapsed: false,
  isUserMenuOpen: false,
  isNotificationMenuOpen: false,
  toggleSidebar: () => set((s) => ({ isSidebarCollapsed: !s.isSidebarCollapsed })),
  setUserMenuOpen: (open) => set({ isUserMenuOpen: open }),
  setNotificationMenuOpen: (open) => set({ isNotificationMenuOpen: open }),
}));
